import * as React from 'react'

function SvgNotiStar(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1zm-1.241 5.938l-1.07 2.256-2.39.362c-1.33.201-1.731 1.48-.768 2.458l1.73 1.756-.408 2.48c-.227 1.378.817 2.17 2.008 1.518l2.14-1.17 2.138 1.17c1.19.651 2.235-.138 2.008-1.519l-.409-2.48 1.73-1.755c.963-.977.565-2.256-.766-2.458l-2.392-.362-1.064-2.244c-.596-1.258-1.89-1.271-2.487-.012z"
      />
    </svg>
  )
}

export default SvgNotiStar
